import { connect } from 'react-redux';
import { AppState } from 'src';
import {
  VendorDuplicateReviewComponent,
  VendorDuplicateReviewComponentProperties
} from './vendor-duplicate-review.component';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<VendorDuplicateReviewComponentProperties> {
  return {
    vendorSearchResults: state.vendorMaintenance.searchResults,
    vendorSearchPageCount: state.vendorMaintenance.searchPageCount
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const VendorDuplicateReviewContainer = connect(mapStateToProps)(VendorDuplicateReviewComponent);



// WEBPACK FOOTER //
// ./src/vendor/_components/flows/steps/general-info/vendor-duplicate-review.container.ts